class AssetDictionary {
  #dictionary = new Map();

  set(key, value) {
    this.#dictionary.set(key, value);
  }

  get(key) {
    return this.#dictionary.get(key);
  }

  remove(key) {
    this.#dictionary.set(key);
  }
}

const assetDictionary = new AssetDictionary();
export { assetDictionary, AssetDictionary };
